// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Ql7G","errorLogs":"EditorFooter_errorLogs__2e9Yp"};